import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SimpleTitle } from '@models/Title';

import { RootState } from '..';

import { AddSimpleTitlesPayload } from './types';

export type TitlesState = {
  [masterId: string]: SimpleTitle;
};

const initialState: TitlesState = {};

// SELECTORS
export const getSimpleTitle = (masterId: string) => (state: RootState) => state.titles[masterId];

// SLICE
export const titlesSlice = createSlice({
  name: 'titles',
  initialState,
  reducers: {
    addSimpleTitles: (state, { payload: { titles } }: PayloadAction<AddSimpleTitlesPayload>) => {
      titles.forEach(title => {
        state[title.masterId] = title;
      });
    },
  },
});

export const { actions: titlesActions } = titlesSlice;

export default titlesSlice.reducer;
